import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface ForecastProject {
  id: string;
  name: string;
  customerId: string | null;
  customerName: string;
  opportunityId: string | null;
  opportunityTitle: string | null;
  status: string;
  currentScopingStage: string | null;
  totalCost: number;
  totalAdjustedDays: number;
  currency: 'GBP' | 'USD' | 'EUR';
  weight: number;
  weightedValue: number;
}

export interface ForecastFunnelStage {
  stage: string;
  weight: number;
  count: number;
  rawValue: number;
  weightedValue: number;
}

export interface PipelineForecast {
  summary: {
    committedValue: number;
    pipelineRawValue: number;
    pipelineWeightedValue: number;
    totalForecast: number;
    committedCount: number;
    pipelineCount: number;
  };
  funnel: ForecastFunnelStage[];
  committed: ForecastProject[];
  pipeline: ForecastProject[];
}

export function usePipelineForecast() {
  return useQuery({
    queryKey: ['forecast', 'pipeline'],
    queryFn: () => api.get<PipelineForecast>('/forecast/pipeline'),
    staleTime: 60 * 1000,
  });
}
